// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IOrgBalanceDetailResponse,
  IOrgBalanceResponse,
  IOrgBalancesPageResponse,
} from '../models/index';
import {
    IOrgBalanceDetailResponseFromJSON,
    IOrgBalanceDetailResponseToJSON,
    IOrgBalanceResponseFromJSON,
    IOrgBalanceResponseToJSON,
    IOrgBalancesPageResponseFromJSON,
    IOrgBalancesPageResponseToJSON,
} from '../models/index';

export interface GetChildOrganizationsBalancesRequest {
    parentOrgId: number;
    statuses: Array<GetChildOrganizationsBalancesStatusesEnum>;
    page?: number;
    size?: number;
}

export interface GetOrganizationBalanceDetailsRequest {
    orgId: number;
}

export interface GetOrganizationBalancesRequest {
    orgId: number;
}

/**
 * OmniBalancesControllerApi - interface
 * 
 * @export
 * @interface OmniBalancesControllerApiInterface
 */
export interface OmniBalancesControllerApiInterface {
    /**
     * 
     * @summary Get balance information for all child organizations by parent org
     * @param {number} parentOrgId 
     * @param {Array<'PENDING' | 'ACTIVE' | 'TERMINATED' | 'ACTIVATION_FAILED' | 'PENDING_TERMINATION' | 'EXPRESS_SETUP' | 'ABANDONED' | 'TERMINATION_IN_PROGRESS' | 'PENDING_REACTIVATION'>} statuses 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OmniBalancesControllerApiInterface
     */
    getChildOrganizationsBalancesRaw(requestParameters: GetChildOrganizationsBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalancesPageResponse>>;

    /**
     * Get balance information for all child organizations by parent org
     */
    getChildOrganizationsBalances(requestParameters: GetChildOrganizationsBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalancesPageResponse>;

    /**
     * 
     * @summary Get detailed balance information for an organization including plans
     * @param {number} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OmniBalancesControllerApiInterface
     */
    getOrganizationBalanceDetailsRaw(requestParameters: GetOrganizationBalanceDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalanceDetailResponse>>;

    /**
     * Get detailed balance information for an organization including plans
     */
    getOrganizationBalanceDetails(requestParameters: GetOrganizationBalanceDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalanceDetailResponse>;

    /**
     * 
     * @summary Get balance information for organization
     * @param {number} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OmniBalancesControllerApiInterface
     */
    getOrganizationBalancesRaw(requestParameters: GetOrganizationBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalanceResponse>>;

    /**
     * Get balance information for organization
     */
    getOrganizationBalances(requestParameters: GetOrganizationBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalanceResponse>;

}

/**
 * 
 */
export class OmniBalancesControllerApi extends runtime.BaseAPI implements OmniBalancesControllerApiInterface {

    /**
     * Get balance information for all child organizations by parent org
     */
    async getChildOrganizationsBalancesRaw(requestParameters: GetChildOrganizationsBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalancesPageResponse>> {
        if (requestParameters['parentOrgId'] == null) {
            throw new runtime.RequiredError(
                'parentOrgId',
                'Required parameter "parentOrgId" was null or undefined when calling getChildOrganizationsBalances().'
            );
        }

        if (requestParameters['statuses'] == null) {
            throw new runtime.RequiredError(
                'statuses',
                'Required parameter "statuses" was null or undefined when calling getChildOrganizationsBalances().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/omni-balances/organizations/{parent-org-id}/children`;
        urlPath = urlPath.replace(`{${"parent-org-id"}}`, encodeURIComponent(String(requestParameters['parentOrgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrgBalancesPageResponseFromJSON(jsonValue));
    }

    /**
     * Get balance information for all child organizations by parent org
     */
    async getChildOrganizationsBalances(requestParameters: GetChildOrganizationsBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalancesPageResponse> {
        const response = await this.getChildOrganizationsBalancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed balance information for an organization including plans
     */
    async getOrganizationBalanceDetailsRaw(requestParameters: GetOrganizationBalanceDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalanceDetailResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling getOrganizationBalanceDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/omni-balances/organizations/{org-id}/details`;
        urlPath = urlPath.replace(`{${"org-id"}}`, encodeURIComponent(String(requestParameters['orgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrgBalanceDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get detailed balance information for an organization including plans
     */
    async getOrganizationBalanceDetails(requestParameters: GetOrganizationBalanceDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalanceDetailResponse> {
        const response = await this.getOrganizationBalanceDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get balance information for organization
     */
    async getOrganizationBalancesRaw(requestParameters: GetOrganizationBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrgBalanceResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling getOrganizationBalances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/omni-balances/organizations/{org-id}`;
        urlPath = urlPath.replace(`{${"org-id"}}`, encodeURIComponent(String(requestParameters['orgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrgBalanceResponseFromJSON(jsonValue));
    }

    /**
     * Get balance information for organization
     */
    async getOrganizationBalances(requestParameters: GetOrganizationBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrgBalanceResponse> {
        const response = await this.getOrganizationBalancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetChildOrganizationsBalancesStatusesEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
